module.exports = __webpack_public_path__ + "static/GlitchlessSonyax4f-b8fcc25bc3ec2553b5627f8367ccb33d.png";